/**
 * What a SAS will be signed for, in words (UI/UX fix round A, reviews A1 / U19): the dialog states the exact target
 * before Generate, and an account SAS states that it covers the whole account, not the resource it was opened from.
 */
import type { StorageResourceRef } from '../../../../../../types/azureStorage';
import { hnsSasResourceKind } from '../../../../../../core/engines/azureStorageHnsSas';

export function sasTargetLabel(resource: StorageResourceRef): string {
  switch (resource.kind) {
    case 'account': return 'the whole storage account';
    case 'container': return `container ${resource.container}`;
    case 'blob': return `blob ${resource.container}/${resource.name}`;
    case 'table': return `table ${resource.table}`;
    case 'queue': return `queue ${resource.queue}`;
    case 'share': return `file share ${resource.share}`;
    case 'file': return `file ${resource.share}/${resource.path}`;
    case 'hnsPath': {
      const kind = hnsSasResourceKind(resource);
      if (kind === 'container') return `container ${resource.fileSystem} (the Data Lake file system root)`;
      return kind === 'directory' ? `Data Lake directory ${resource.fileSystem}/${resource.path}/` : `file ${resource.fileSystem}/${resource.path}`;
    }
    default: return resource.kind;
  }
}

/** The account SAS scope sentence: which services, everything in them — and never only the resource it was opened from. */
export function accountSasScope(openedFrom: StorageResourceRef): string {
  const origin = openedFrom.kind === 'account' ? '' : ` — not only ${sasTargetLabel(openedFrom)}`;
  return `An account SAS works on every container, table, queue and file share of the account in the services ticked below${origin}.`;
}

export const ACCOUNT_SAS_RESOURCE_TYPES = 'Resource types: service, container and object (all three).';
